import SectionHeading from '@/pages/home/components/SectionHeading';
import { characters } from '@/mocks/home';

export default function CharactersSection() {
  return (
    <section id="characters" className="border-t border-background-200 bg-background-100 px-4 py-16 md:px-8 md:py-24">
      <div className="mx-auto w-full max-w-6xl">
        <SectionHeading
          eyebrow="角色群像"
          title="六个人，六种活法"
          desc="这部剧没有绝对的主角。每一个出现在同学会上的人，都带着自己没说出口的那部分故事。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 md:mt-14 md:gap-6">
          {characters.map((person) => (
            <article
              key={person.name}
              className="reveal group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="relative h-64 w-full overflow-hidden md:h-72">
                <img
                  src={person.img}
                  alt={`${person.name}角色形象，${person.role}，气质${person.tag}`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-3 py-1 text-xs font-medium text-primary-700 backdrop-blur">
                  {person.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-baseline justify-between gap-3">
                  <h3 className="font-heading text-lg font-bold text-foreground-950">
                    {person.name}
                  </h3>
                  <span className="text-xs text-foreground-500">{person.role}</span>
                </div>
                <p className="mt-3 flex-1 text-sm leading-7 text-foreground-600">{person.desc}</p>
                <p className="mt-4 border-l-2 border-accent-400 pl-3 text-sm italic leading-6 text-foreground-700">
                  “{person.quote}”
                </p>
              </div>
            </article>
          ))}
        </div>

        <p className="reveal mt-8 text-center text-xs leading-6 text-foreground-500 md:text-sm">
          角色设定与人物关系由剧迷根据公开资料整理，具体以官方播出内容为准。
        </p>
      </div>
    </section>
  );
}